import React, { useEffect, ReactNode } from 'react';
import { observer } from 'mobx-react';

import './scss/common-head.scss';
import Color from '@tool/color';
import { ChartIconActive, ChartIconInActive, TableIconActive, TableIconInActive } from '@/styled/icon';
import { IconButton } from '@mui/material';
import { styled } from '@mui/system';

interface IProps {
  title: string,
  subTitle?: string,
  type?: string,
  bgColor?: string,
  fontColor?: string,
  contentList?: Array<any>,
  details?: string
  onChange: (val: string) => void,
}
interface IState { }

const CommonHead = (props: IProps, state: IState) => {

  const DIconButton = styled(IconButton)(() => ({
    width: '32px',
    height: '20px',
    marginRight: '2px',
    borderRadius: '3px',
  }));

  const ActiveType = styled(DIconButton)(() => ({
    backgroundColor: Color.primary,
    '&:hover': { backgroundColor: Color.primary },
  }));
  const { title, subTitle, type, bgColor, fontColor, contentList, details, onChange } = props;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="common-head">
      <section className='top'>
        {title && <b className="title">{title}</b>}
        {subTitle && <span style={{ backgroundColor: bgColor, color: fontColor }} className='subtitle'>{subTitle}</span>}
        {type && <p className='icon-group'>
          {type === 'chart' ? (
            <ActiveType>
              <ChartIconActive />
            </ActiveType>
          ) : (
            <DIconButton onClick={() => { onChange('chart') }}>
              <ChartIconInActive />
            </DIconButton>
          )}
          {type === 'table' ? (
            <ActiveType>
              <TableIconActive />
            </ActiveType>
          ) : (
            <DIconButton onClick={() => { onChange('table') }}>
              <TableIconInActive />
            </DIconButton>
          )}
        </p>}
      </section>
      {details && <section className='com-details'>
        <p>{details}</p>
      </section>}
      <section className='content'>
        {
          contentList?.map((res: any, r: any) => {
            return <p key={r}>{res}</p>
          })
        }
      </section>
    </section>
  );
};

export default observer(CommonHead);
